import { arrayReducer } from './array'
import { sortObjectKey, sortObjectValues, mergeObjects } from './object'

const Utils = {
  arrayReducer,
  sortObjectKey,
  sortObjectValues,
  mergeObjects
}

export default Utils



// WEBPACK FOOTER //
// ./src/utils/index.js